<template>
    <div id="app">
      <loading-overlay :is-loading="isLoading"></loading-overlay>
      <router-view></router-view>
    </div>
  </template>

<script>
    import LoadingOverlay from "./components/LoadingOverlay";
    import HelperMixin from "./mixins/HelperMixin";

    export default {
    name: "app",
    components: {
      LoadingOverlay,
    },
    mixins: [HelperMixin],
    data() {
      return {
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters["isLoading"];
      }
    },
    mounted() {
      
    },
    beforeDestroy() {
      
    },
    created() {
      /*
      if (typeof this.$store.getters['appLanguage'] == 'undefined') {
        var userLang = navigator.language || navigator.userLanguage;
        var userLangArray = userLang.split('-');
        userLang = userLangArray[0];
        var exists = this.$te('login.email', userLang);
        if (!exists) {
          userLang = 'en';
        }
        this.$i18n.locale = userLang;
        this.$store.dispatch('saveAppLanguage', {
            appLanguage: userLang
        });
      }
    */
    },
    methods: {
      
    }
  };
</script>
